// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_n_e","cls2":"Header-cls2_kBz Header-cls1_n_e","small":"Header-small_xYZ"};